import type { OverlayTheme } from "../overlay-theme";
import { lookupValue } from "../../theme-util";
import type { FlattenSimpleInterpolation } from "styled-components";

export const largeListItemOverlay: OverlayTheme = {
    overlayName: "LargeListItemOverlay",
    listItem: {
        defaultRowHeight: 86,
        underlineLeft: lookupValue<number>("pageMarginMedium"),
        underlineRight: lookupValue<number>("pageMarginMedium"),

        mainImage: {
            width: 62,
            height: 62,
            borderRadius: "4px",
        },
    },
};

export const bigCaptionListItemOverlay: OverlayTheme = {
    overlayName: "BigCaptionListItem",
    listItem: {
        captionFontStyle: lookupValue<FlattenSimpleInterpolation>("fontStyles.Body4"), //was 16px not 17px
        captionAlign: "right",
    },
};
